'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _cascadingMenu = require('@/components/cascading-menu');

var _cascadingMenu2 = _interopRequireDefault(_cascadingMenu);

var _imagePath = require('@/mixins/image-path');

var _imagePath2 = _interopRequireDefault(_imagePath);

var _utils = require('@/utils');

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _isLogin = require('@/mixins/isLogin');

var _isLogin2 = _interopRequireDefault(_isLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_imagePath2.default, _isLogin2.default],
  data: function data() {
    return {
      menuTitle: '课程分类',
      animate: _utils.animate,
      listData: [], //菜单数据
      cascadLoadding: true, //菜单加载
      carouseLoadding: true, //轮播加载
      carouselData: [], //轮播mock数据
      progress: 0,
      hasCheck: false,
      iconList: [], // 课程分类图标
      userCheckTarget: []
    };
  },
  created: function created() {
    this.timeFormat = _utils.timeFormat;
    this.allMenu = {};
    this.getTopicsCourseData();
  },

  methods: {
    //专题详情
    beginStart: function beginStart(item) {
      this.$router.push({
        path: '/course/course-topics',
        query: {
          topicsCourseID: item.topicsCourseID
        }
      });
    },
    goDetail: function goDetail(item) {
      // if (!this.isLogin('login')) return
      window.open(item.link);
    },

    //获取课程分类
    getCascadingData: function getCascadingData() {
      var _this = this;

      this.$parent.$emit('addasyncAll');
      this.$ajax({
        url: 'api-basic/portal/open/category/tree',
        method: 'get',
        data: {
          categoryCode: 'courseCategory',
          categoryID: this.categoryId
        }
      }).then(function (res) {
        return res.data.data.slice(0, 9);
      }).then(function (result) {
        // 获取课程分类图标
        _this.$ajax({
          url: 'zuul/api-file/portal/open/file/group/3fc6812a-178b-11ec-9f5e-6282695083c7',
          method: 'get',
          data: {
            pageSize: '-1'
          }
        }).then(function (res) {
          _this.iconList = res.data.data;
          _this.listData = _this.editTreeData(result, _this.iconList);
          _this.cascadLoadding = false;
        });
      }).finally(function () {
        _this.$parent.$emit('finishAsyncAll');
      });
    },

    // 编辑分类图片
    editTreeData: function editTreeData(tree, list) {
      var _this2 = this;

      tree.forEach(function (item) {
        list.forEach(function (ion) {
          if (item.code == ion.name) {
            item.iconImg = ion.fileID;
          }
        });
        if (item.children && item.children.length) {
          _this2.editTreeData(item.children, list);
        }
      });
      return tree;
    },

    //获取课程分类
    getTopicsCourseData: function getTopicsCourseData() {
      var _this3 = this;

      this.$parent.$emit('addasyncAll');
      this.$ajax({
        url: 'api-information/portal/open/banner',
        method: 'get',
        data: {
          searchBannerTypeCode: 'banner'
        }
      }).then(function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(res) {
          var arr, i, mod;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  arr = res.data.data || [];

                  if (!(arr == null)) {
                    _context.next = 5;
                    break;
                  }

                  arr = [{ imagePath: '' }];
                  _context.next = 17;
                  break;

                case 5:
                  i = 0;

                case 6:
                  if (!(i < arr.length)) {
                    _context.next = 17;
                    break;
                  }

                  mod = arr[i];
                  _context.next = 10;
                  return _this3.getImgSrc('imgUrl', 'course', mod.imageID, 'open');

                case 10:
                  _context.t0 = _context.sent;
                  _context.t1 = _context.t0 + '&time=';
                  _context.t2 = new Date().getTime();
                  mod.imagePath = _context.t1 + _context.t2;

                case 14:
                  i++;
                  _context.next = 6;
                  break;

                case 17:
                  _this3.carouselData = arr;
                  _this3.carouseLoadding = false;

                case 19:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).finally(function () {
        _this3.$parent.$emit('finishAsyncAll');
      });
    },

    //选择父分类
    check: function check(item, val) {
      this.$router.push({
        path: '/course/course-list',
        query: {
          categoryID: val.id,
          categoryName: val.title
        }
      });
    },

    //选择子分类
    checkMenu: function checkMenu(item) {
      this.$router.push({
        path: '/course/course-list',
        query: {
          categoryID: item.id,
          categoryName: item.title
        }
      });
    },
    onChangeCarousel: function onChangeCarousel(start, end) {
      var ivuCarouselTrack = document.getElementsByClassName('ivu-carousel-track')[0];
      if (document.querySelectorAll('.iv-broadcast-r-t .ivu-carousel-item')[0]) {
        var itemWidth = document.querySelectorAll('.iv-broadcast-r-t .ivu-carousel-item')[0].style.width;
        (0, _utils.animate)(start, end, ivuCarouselTrack, itemWidth);
      }
    }
  },
  components: {
    cascading: _cascadingMenu2.default,
    Iconfont: _iconfont2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//